import { getSupportedThemes } from './getSupportedThemes';
import { setCssVariablesOnDocument } from '../utils/setCssVariablesOnDocument';
import { setIsDarkThemeFromThemeMode } from '../mutators/setIsDarkThemeFromThemeMode';
import { setThemeColorOnDocument } from '../utils/setThemeColorOnDocument';
import { setThemeId } from '../mutators/setThemeId';
import { setThemeMode } from '../mutators/setThemeMode';
import { type ThemeId } from '../schema/ThemeId';
import type { ThemeMode } from '../schema/ThemeMode';
import {
    setThemeIdInLocalStorage,
    setThemeColorInLocalStorage,
    setThemeModeInLocalStorage,
} from './localStorageThemeSettingUtils';

/**
 * Updates theme info in the store and set the css variables on the document
 */
export const loadTheme = (themeId: ThemeId, themeMode: ThemeMode): void => {
    const supportedThemes = getSupportedThemes();
    if (supportedThemes.indexOf(themeId) === -1) {
        themeId = 'Blue';
    }

    // Update store
    setThemeId(themeId);
    setThemeMode(themeMode);
    setIsDarkThemeFromThemeMode(themeMode);

    // Update local storage
    setThemeIdInLocalStorage(themeId);
    setThemeColorInLocalStorage(themeId);
    setThemeModeInLocalStorage(themeMode);

    // Update document
    setCssVariablesOnDocument();
    setThemeColorOnDocument();
};
